import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";
import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'add-labo',
  templateUrl: './add-labo.component.html',
  styleUrls: ['./add-labo.component.css']
})
export class AddLaboComponent {
  errors: any = {};
  isLoading: boolean = false;
  isUpdate: boolean = false;
  isAccount: boolean = false;

  laboratory: any = {
    email: '',
    name: '',
    long_name: '',
    legal_form: null,
    rcs: '',
    capital: '',
    phone: '',
    siren: '',
    siret: '',
    address: '',
    zipcode: '',
    city: '',
    country: 'France',
    users: []
  };

  possibleLegalForm: any = [
    { value: 'EI', text: 'EI - Entreprise individuelle' },
    { value: 'EIRL', text: 'EIRL - Entreprise individuelle à responsabilité limitée' },
    { value: 'EURL', text: 'EURL - Entreprise unipersonnelle à responsabilité limitée' },
    { value: 'SARL', text: 'SARL - Société à responsabilité limitée' },
    { value: 'SA', text: 'SA - Société anonyme' },
    { value: 'SAS', text: 'SAS - Société par actions simplifiée' },
    { value: 'SASU', text: 'SASU - Société par actions simplifiée unipersonnelle' },
    { value: 'SC', text: 'SC - Société civile' },
    { value: 'SCA', text: 'SCA - Société en commandite par actions' },
    { value: 'SCI', text: 'SCI - Société civile immobilière' },
    { value: 'SCIC', text: 'SCIC - Société coopérative d\'intérêt collectif' },
    { value: 'SCM', text: 'SCM - Société civile de moyens' },
    { value: 'SCP', text: 'SCP - Société civile professionnelle' },
    { value: 'SCS', text: 'SCS - Société en commandite simple' },
    { value: 'SEL', text: 'SEL - Société d\'exercice libéral' },
    { value: 'SELAFA', text: 'SELAFA - Société d\'exercice libéral à forme anonyme' },
    { value: 'SELARL', text: 'SELARL - Société d\'exercice libéral à responsabilité limitée' },
    { value: 'SELAS', text: 'SELAS - Société d\'exercice libéral par actions simplifiée' },
    { value: 'SELCA', text: 'SELCA - Société d\'exercice libéral en commandite par actions' },
    { value: 'SEM', text: 'SEM - Société d\'économie mixte' },
    { value: 'SEML', text: 'SEML - Société d\'économie mixte locale' },
    { value: 'SEP', text: 'SEP - Société en participation' },
    { value: 'SICA', text: 'SICA - Société d\'intérêt collectif agricole' },
    { value: 'SNC', text: 'SNC - Société en nom collectif' }
  ];

  environment: any;

  curUser: any = {
    email: '',
    phone: '',
    firstname: '',
    lastname: '',
    password: '',
    confirm_password: ''
  };

  @ViewChild('userForm')
  userFormVariable: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {

      let path = this.route.routeConfig.path
      let id = params['id'];
      if (path == 'mon-compte') {
        if (this.authService.currentIsAdmin())
          this.router.navigate(['administration', 'home']);
        else {
          this.isUpdate = true;
          this.isAccount = true;
          this.isLoading = true;
          var url = environment.API_PATH + '/laboratory/' + this.authService.connectedAs.id;
          url += this.authService.session.user.account_type === 'admin' ? "?connectedAsId=" + this.authService.connectedAs.id : '';
          this.http.get(url, {withCredentials: true})
	        .subscribe(
            data => {
              this.laboratory = data;
              this.isLoading = false;
            },
            err => {
              var errors = err.error;
              this.isLoading = false;
              if (errors.error) {
                if (errors.error.status === 401) {

                  this.router.navigate(['/connexion']);
                } else if (errors.error.status === 403) {
                  if (errors.error.details.redirect)
                    this.router.navigate([errors.error.details.redirect]);
                  else
                    this.router.navigate(['connexion']);
                } else if (errors.error.status === 404) {
                  this.authService.logout();
                }
                else {
                  this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
                }
              } else {
                this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
              }
            });
        }
      }
      else {
        if (id) {
          this.isUpdate = true;
          this.isLoading = true;
          this.http.get(environment.API_PATH + '/laboratory/' + id, {withCredentials: true})
          .subscribe(
            data => {
              this.laboratory = data;
              this.isLoading = false;
            },
            err => {
              var errors = err.error;
              this.isLoading = false;
              if (errors.error) {
                if (errors.error.status === 401) {

                  this.router.navigate(['/connexion']);
                } else if (errors.error.status === 403) {
                  if (errors.error.details.redirect)
                    this.router.navigate([errors.error.details.redirect]);
                  else
                    this.router.navigate(['connexion']);
                } else {
                  this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
                }
              } else {
                this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
              }
          });
        }
      }
    });
  }

  initUserForm() {
    for (var i in this.userFormVariable.controls) {
      this.userFormVariable.controls[i].markAsUntouched();
      this.userFormVariable.controls[i].reset();
    }
    this.userFormVariable.submitted = false;
    this.userFormVariable.reset();
  }

  addUser() {
    if (this.userFormVariable.invalid)
      return;

    var found = false;
    for (var i in this.laboratory.users) {
      if (this.laboratory.users[i].email == this.curUser.email)
        found = true;
    }
    if (!found)
      this.laboratory.users.push(_.cloneDeep(this.curUser));
    this.initUserForm();
  }

  removeUser(email) {
    for (var i in this.laboratory.users) {
      if (this.laboratory.users[i].email == email) {
        this.laboratory.users.splice(i, 1);
        break;
      }
    }
  }

  cancelSubmit() {
    this.router.navigate(['../..'], {relativeTo: this.route});
  }

  valueChange(field) {
    delete this.errors[field];
  }

  goBack() {
    this.router.navigate(['administration', 'laboratoires']);
  }

  submitForm(form) {
    this.initUserForm();
    this.errors = {};

    if (form.invalid)
      return;

    this.isLoading = true;

    let path = this.route.routeConfig.path;
    let query = '';
    if (path == 'mon-compte') {
      query += this.authService.session.user.account_type === 'admin' ? "?connectedAsIs" + this.authService.connectedAs.id : '';
    }
    if (!this.laboratory.id)
      var req = this.http.post(environment.API_PATH + '/laboratory/add' + query, this.laboratory, {withCredentials: true});
    else {
      var req = this.http.put(environment.API_PATH + '/laboratory/update' + query, this.laboratory, {withCredentials: true});
    }

    req
    .subscribe(response => {
      this.isLoading = false;
      if (!this.laboratory.id) {
        this.utilsService.displayNotif('Le laboratoire a bien été créé', 'success');
        this.router.navigate([this.router.url.split('/')[1], 'laboratoires']);
      }
      else if (this.route.routeConfig.path !== 'mon-compte') {
        this.utilsService.displayNotif('Le laboratoire a bien été modifié', 'success');
        this.router.navigate([this.router.url.split('/')[1], 'laboratoires']);
      }
      else {
        this.utilsService.displayNotif('Votre compte a bien été modifié', 'success');
        this.router.navigate(['administration', 'home']);
      }

    }, err => {

      this.isLoading = false;
      if (err.status === 401) {
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else if (errors.error.redirect) {
              this.router.navigate([errors.error.redirect]);
            }
            else
              this.authService.logout()
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      } else if (err.status == 400) {
        var details = err.error.error.details;
        if (!_.isEmpty(details)) {
          if ('general' in details) {
            for (var i in details.general) {
              this.utilsService.displayNotif(details.general[i], "danger");
            }
          }
          if ('field' in details) {
            for (var i in details.field) {
              if (i == 'users') {
                this.removeUser(details.field[i].email);
                this.utilsService.displayNotif("Un ou plusieurs utilisateurs sont déja existants et ont été suprimés, merci de réessayer", "danger");
              }
              else
                this.errors[i] = details.field[i];
            }
          }
        }
      }
      else {
        this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/add-labo/add-labo.component.ts